import { format, utcToZonedTime } from "date-fns-tz";

const formatAmount = (amount) => {
  return new Intl.NumberFormat("en-IN").format(Math.trunc(amount));
};

const formattedDateTime = (date_to_format) => {
  let formatted_date = new Date(date_to_format).toLocaleString();
  formatted_date = formatted_date.split(", ");
  const year = formatted_date[0].split("/")[2],
    month = formatted_date[0].split("/")[1],
    date = formatted_date[0].split("/")[0],
    time = formatted_date[1];
  return (formatted_date = `${year}-${month}-${date} ${time}`);
};

const convertToUTCFormat = (date, fmt) => {
  return format(utcToZonedTime(date, "UTC"), fmt, {
    timeZone: "UTC",
  });
};

export { formatAmount, formattedDateTime, convertToUTCFormat };
